<template>
  <div class="container-fluid py-4">
    <!-- Status Filter Buttons -->
    <div class="card mb-4" v-if="groupped">
      <div class="card-header pb-0">
        <h6 class="mb-3">Relatório de Produtos por Data</h6>
        <div class="row">
          <div class="col-12">
            <div
              class="btn-group w-100"
              role="group"
              aria-label="Status filter"
            >
              <button
                type="button"
                class="btn btn-sm"
                :class="
                  varStatus == 'ATIVO' ? 'btn-success' : 'btn-outline-success'
                "
                @click="chageStatus('ATIVO')"
              >
                <i class="fas fa-check-circle me-1"></i>
                ATIVOS
                <span class="badge bg-white text-success ms-1 text-xs">{{
                  getStatusCount("ATIVO")
                }}</span>
              </button>
              <button
                type="button"
                class="btn btn-sm"
                :class="
                  varStatus == 'RETIRADO'
                    ? 'btn-warning'
                    : 'btn-outline-warning'
                "
                @click="chageStatus('RETIRADO')"
              >
                <i class="fas fa-shopping-bag me-1"></i>
                RETIRADOS
                <span class="badge bg-white text-warning ms-1 text-xs">{{
                  getStatusCount("RETIRADO")
                }}</span>
              </button>
              <button
                type="button"
                class="btn btn-sm"
                :class="
                  varStatus == 'CANCELADO' ? 'btn-danger' : 'btn-outline-danger'
                "
                @click="chageStatus('CANCELADO')"
              >
                <i class="fas fa-times-circle me-1"></i>
                CANCELADOS
                <span class="badge bg-white text-danger ms-1 text-xs">{{
                  getStatusCount("CANCELADO")
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content - Orders by Date -->
    <div v-if="sections && sections.length > 0">
      <div
        class="card mb-4 border-0 shadow-lg"
        v-for="(sec, ix) in sections"
        :key="ix"
      >
        <!-- Date Header -->
        <div class="card-header date-header" :class="getStatusHeaderClass()">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div
                class="icon icon-shape icon-sm bg-white shadow-sm rounded-circle me-2"
              >
                <i class="fas fa-calendar-alt text-dark text-xs"></i>
              </div>
              <div>
                <h6 class="mb-0 text-white text-sm">
                  {{ formatDate(sec.date) }}
                </h6>
                <small class="text-white opacity-8 text-xs"
                  >{{ sec.pedidos.length }} pedido(s)</small
                >
              </div>
            </div>
            <div class="text-end">
              <span class="badge bg-white text-dark text-xs">
                Total: R$ {{ calculateDayTotal(sec.pedidos) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Orders List -->
        <div class="card-body p-0">
          <div class="accordion" :id="'accordion-' + ix">
            <div
              class="accordion-item border-0"
              v-for="(ped, ii) in sec.pedidos"
              :key="ii"
            >
              <!-- Order Header -->
              <h2 class="accordion-header">
                <button
                  class="accordion-button order-header"
                  :class="{ collapsed: !isItemOpen(ix, ii) }"
                  type="button"
                  @click="toggleItem(ix, ii)"
                  :aria-expanded="isItemOpen(ix, ii)"
                >
                  <div class="row w-100 align-items-center">
                    <div class="col-md-2">
                      <span
                        class="badge badge-order bg-gradient-primary text-xs px-2 py-1"
                      >
                        #{{ ped.pednum }}
                      </span>
                    </div>
                    <div class="col-md-4">
                      <div class="d-flex align-items-center">
                        <div
                          class="avatar avatar-sm bg-gradient-secondary rounded-circle me-2"
                        >
                          <span class="text-white text-xs">{{
                            getInitials(ped.cliente.nome)
                          }}</span>
                        </div>
                        <div class="d-flex flex-column">
                          <span
                            class="fw-bold text-dark text-capitalize text-sm"
                            >{{ ped.cliente.nome.toLowerCase() }}</span
                          >
                          <small class="text-muted text-xxs">
                            <i class="fas fa-phone-alt me-1"></i>
                            {{ formatPhone(ped.cliente.fone) }}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2 text-center">
                      <span :class="getStatusBadgeClass(ped.status)">
                        {{ ped.status }}
                      </span>
                    </div>
                    <div class="col-md-2 text-center">
                      <span class="text-xs text-muted">
                        <i class="fas fa-box me-1"></i>
                        {{ ped.produtos.length }} item(s)
                      </span>
                    </div>
                    <div class="col-md-2 text-end">
                      <span class="fw-bold text-success text-sm">
                        R$ {{ formatCurrency(ped.total) }}
                      </span>
                    </div>
                  </div>
                </button>
              </h2>

              <!-- Products Detail -->
              <div
                class="accordion-collapse"
                :class="{
                  collapse: !isItemOpen(ix, ii),
                  show: isItemOpen(ix, ii),
                }"
              >
                <div class="accordion-body bg-gray-100 p-4">
                  <div class="table-responsive">
                    <table
                      class="table table-hover align-items-center mb-0 bg-white rounded-3 shadow-sm"
                    >
                      <thead class="bg-gradient-light">
                        <tr>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-3"
                          >
                            Produto
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                          >
                            Quantidade
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end pe-3"
                          >
                            Preço Unit.
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end pe-3"
                          >
                            Subtotal
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(pro, ip) in ped.produtos" :key="ip">
                          <td class="ps-3">
                            <div class="d-flex align-items-center">
                              <div
                                class="icon icon-shape icon-sm bg-gradient-warning rounded-circle me-3"
                              >
                                <i class="fas fa-drumstick-bite text-white"></i>
                              </div>
                              <span class="fw-bold">{{ pro.produto }}</span>
                            </div>
                          </td>
                          <td class="text-center">
                            <span
                              class="badge bg-light text-dark text-sm px-2 py-1"
                            >
                              {{ pro.quant }}
                            </span>
                          </td>
                          <td class="text-end pe-3">
                            <span class="text-sm text-muted">
                              R$ {{ formatCurrency(pro.total || 0) }}
                            </span>
                          </td>
                          <td class="text-end pe-3">
                            <span class="fw-bold text-dark">
                              R$
                              {{
                                formatCurrency(
                                  (pro.quant || 0) * (pro.total || 0)
                                )
                              }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot class="border-top">
                        <tr>
                          <td
                            colspan="3"
                            class="text-end fw-bold text-uppercase text-sm pe-3"
                          >
                            Total do Pedido:
                          </td>
                          <td class="text-end pe-3">
                            <span class="badge bg-success text-xs px-2 py-1">
                              R$ {{ formatCurrency(ped.total) }}
                            </span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div v-else class="card">
      <div class="card-body text-center py-5">
        <div
          class="icon icon-shape icon-xl bg-gradient-secondary rounded-circle mx-auto mb-3"
        >
          <i class="fas fa-inbox text-white fs-4"></i>
        </div>
        <h5 class="text-muted">Nenhum pedido encontrado</h5>
        <p class="text-sm text-muted">
          Não há pedidos com o status selecionado.
        </p>
      </div>
    </div>

    <!-- Summary Section - Only for ATIVO status -->
    <div
      class="card mt-4 border-0 shadow-lg"
      v-if="varStatus == 'ATIVO' && objSomas && objSomas.length > 0"
    >
      <div class="card-header bg-gradient-dark">
        <div class="d-flex align-items-center">
          <div
            class="icon icon-shape icon-md bg-white shadow-sm rounded-circle me-3"
          >
            <i class="fas fa-chart-pie text-dark"></i>
          </div>
          <div>
            <h6 class="mb-0 text-white text-sm">Resumo de Totais</h6>
            <small class="text-white opacity-8 text-xxs"
              >Produtos em pedidos ativos</small
            >
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div
            class="col-12 col-lg-6 mb-4"
            v-for="(item, ix) in objSomas"
            :key="ix"
          >
            <div class="card h-100 border shadow-sm">
              <div class="card-header bg-light py-3">
                <div class="d-flex align-items-center">
                  <i class="fas fa-calendar-day text-primary me-2"></i>
                  <h6 class="mb-0">{{ formatDate(item.data) }}</h6>
                </div>
              </div>
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th
                          class="text-uppercase text-secondary text-xxs font-weight-bolder ps-3"
                        >
                          Produto
                        </th>
                        <th
                          class="text-uppercase text-secondary text-xxs font-weight-bolder text-end pe-3"
                        >
                          Quantidade Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(soma, produtoNome, ikx) in item.produtos"
                        :key="produtoNome"
                      >
                        <td class="ps-3">
                          <div class="d-flex align-items-center">
                            <span
                              class="bullet bullet-sm bg-warning me-2"
                            ></span>
                            <span class="text-sm fw-bold">{{
                              produtoNome
                            }}</span>
                          </div>
                        </td>
                        <td class="text-end pe-3">
                          <span
                            class="badge bg-gradient-info text-xs px-2 py-1"
                          >
                            {{ item.totais.soma[ikx] }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div v-if="loading" class="card">
      <div class="card-body text-center py-5">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
        <h5 class="text-muted">Carregando pedidos...</h5>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mask } from "vue-the-mask";
import _ from "lodash";
import { getAllPedidosNoPagination } from "../../service/ApiPedido";

export default {
  name: "RelProdutosPorDataTable",

  data() {
    return {
      pedido_id: "",
      groupped: {},
      sections: {},
      varStatus: "ATIVO",
      objSomas: {},
      pedidos: [],
      loading: true,
      openItems: {},
    };
  },

  methods: {
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
    formatPhone(fone) {
      if (!fone) return "-";
      const phone = String(fone).replace(/\D/g, "");
      if (phone.length < 10) return fone;
      return (
        "(" +
        phone.slice(0, 2) +
        ") " +
        phone.slice(2, 7) +
        "-" +
        phone.slice(7)
      );
    },
    formatCurrency(value) {
      return Number(value).toFixed(2).replace(".", ",");
    },
    changeDot(strv) {
      return String(Number(strv).toFixed(2)).replace(".", ",");
    },
    getInitials(name) {
      if (!name || typeof name !== "string") return "??";
      // Filter out empty strings from split and trim each part
      const parts = name.split(" ").filter((part) => part && part.length > 0);
      if (parts.length >= 2) {
        const first = parts[0][0] || "";
        const last = parts[parts.length - 1][0] || "";
        return (first + last).toUpperCase() || "??";
      }
      if (parts.length === 1 && parts[0].length >= 2) {
        return parts[0].substring(0, 2).toUpperCase();
      }
      return name.trim().substring(0, 2).toUpperCase() || "??";
    },
    getStatusCount(status) {
      if (!this.pedidos || !this.pedidos.length) return 0;
      return this.pedidos.filter((p) => p.status === status).length;
    },
    getStatusBadgeClass(status) {
      const classes = {
        ATIVO: "badge bg-gradient-success text-sm",
        RETIRADO: "badge bg-gradient-warning text-sm",
        CANCELADO: "badge bg-gradient-danger text-sm",
      };
      return classes[status] || "badge bg-secondary text-sm";
    },
    getStatusHeaderClass() {
      const classes = {
        ATIVO: "bg-gradient-success text-sm",
        RETIRADO: "bg-gradient-warning text-sm",
        CANCELADO: "bg-gradient-danger text-sm",
      };
      return classes[this.varStatus] || "bg-gradient-dark text-sm";
    },
    calculateDayTotal(pedidos) {
      if (!pedidos) return "0,00";
      const total = pedidos.reduce(
        (sum, ped) => sum + Number(ped.total || 0),
        0
      );
      return this.formatCurrency(total);
    },
    toggleItem(ix, ii) {
      const key = `${ix}-${ii}`;
      this.openItems[key] = !this.openItems[key];
    },
    isItemOpen(ix, ii) {
      const key = `${ix}-${ii}`;
      return this.openItems[key] || false;
    },
    chageStatus(status) {
      this.varStatus = status;
      this.openItems = {};
      this.updateData();
    },
    updateData() {
      const filtered = this.pedidos.filter(
        (ped) => ped.status === this.varStatus
      );
      this.groupped = _.groupBy(filtered, (ped) =>
        ped.dataretirada.substring(0, 10)
      );

      this.sections = _.map(this.groupped, (items, date) => ({
        date: date,
        pedidos: items,
      }));

      // Sort sections by date
      this.sections.sort((a, b) => new Date(a.date) - new Date(b.date));

      if (this.varStatus === "ATIVO") {
        this.objSomas = _.map(this.groupped, (item, dataagr) => ({
          data: dataagr,
          produtos: _.groupBy(
            _.flatten(_.flatMap(item, "produtos")),
            "produto"
          ),
          totais: {
            soma: _.map(
              _.groupBy(_.flatten(_.flatMap(item, "produtos")), "produto"),
              (k) => _.sumBy(k, (i) => Number(i.quant))
            ),
          },
        }));
      }
    },
  },

  async mounted() {
    this.loading = true;
    try {
      this.pedidos = await getAllPedidosNoPagination();
      this.updateData();
    } catch (error) {
      console.error("Error loading pedidos:", error);
    } finally {
      this.loading = false;
    }
  },

  directives: { mask },
  components: {},
};
</script>

<style scoped>
.date-header {
  border-radius: 0.5rem 0.5rem 0 0;
}

.order-header {
  background-color: #fff !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 1rem 1.5rem;
}

.order-header:not(.collapsed) {
  background-color: #f8f9fa !important;
}

.order-header::after {
  background-size: 1rem;
  width: 1rem;
  height: 1rem;
}

.accordion-item:last-child .order-header {
  border-radius: 0 0 0.5rem 0.5rem;
}

.accordion-item:last-child .order-header:not(.collapsed) {
  border-radius: 0;
}

.badge-order {
  min-width: 80px;
}

.icon-shape {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-md {
  width: 42px;
  height: 42px;
}

.icon-sm {
  width: 32px;
  height: 32px;
}

.icon-xl {
  width: 64px;
  height: 64px;
}

.avatar {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.bullet {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.bullet-sm {
  width: 6px;
  height: 6px;
}

.bg-gray-100 {
  background-color: #f8f9fa;
}

.opacity-8 {
  opacity: 0.8;
}

.fs-6 {
  font-size: 1rem !important;
}

.rounded-3 {
  border-radius: 0.75rem !important;
}

.shadow-lg {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1) !important;
}

/* Gradient backgrounds */
.bg-gradient-success {
  background: linear-gradient(310deg, #17ad37 0%, #98ec2d 100%);
}

.bg-gradient-info {
  background: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
}

.bg-gradient-danger {
  background: linear-gradient(310deg, #ea0606 0%, #ff667c 100%);
}

.bg-gradient-dark {
  background: linear-gradient(310deg, #141727 0%, #3a416f 100%);
}

.bg-gradient-primary {
  background: linear-gradient(310deg, #5e72e4 0%, #825ee4 100%);
}

.bg-gradient-warning {
  background: linear-gradient(310deg, #f53939 0%, #fbcf33 100%);
}

.bg-gradient-secondary {
  background: linear-gradient(310deg, #627594 0%, #a8b8d8 100%);
}

.bg-gradient-light {
  background: linear-gradient(310deg, #f8f9fa 0%, #e9ecef 100%);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .btn-group {
    flex-direction: column;
  }

  .btn-group .btn {
    border-radius: 0.5rem !important;
    margin-bottom: 0.5rem;
  }

  .order-header .row > div {
    margin-bottom: 0.5rem;
  }

  .order-header .col-md-2,
  .order-header .col-md-4 {
    text-align: left !important;
  }

  .order-header .col-md-2:last-child {
    text-align: right !important;
  }
}

/* Animation for accordion */
.accordion-collapse {
  overflow: hidden;
  transition: max-height 0.35s ease;
}

.accordion-collapse.collapse:not(.show) {
  display: none;
}

.accordion-collapse.show {
  display: block;
}

/* Table hover effect */
.table-hover tbody tr:hover {
  background-color: rgba(94, 114, 228, 0.05);
  transition: background-color 0.15s ease;
}
</style>
